import React, { createContext, useContext, useEffect, useState } from 'react';
import { getPublicTexts } from '../services/cms';

const TextsContext = createContext(null);

export const TextsProvider = ({ children }) => {
  const [texts, setTexts] = useState({});
  useEffect(() => { getPublicTexts().then((d) => setTexts(d || {})).catch(() => setTexts({})); }, []);
  // t(key, fallback) : renvoie le texte publié, sinon le fallback fourni par la page.
  const t = (key, fallback = '') => {
    const v = texts[key];
    return v === undefined || v === null || v === '' ? fallback : v;
  };
  const bool = (key, fallbackTrue = true) => {
    const v = texts[key];
    if (v === undefined || v === null || v === '') return fallbackTrue;
    return String(v).toLowerCase() === 'true';
  };
  return <TextsContext.Provider value={{ texts, t, bool }}>{children}</TextsContext.Provider>;
};

export const useTexts = () => {
  const ctx = useContext(TextsContext);
  if (!ctx) return { texts: {}, t: (k, f = '') => f, bool: (k, f = true) => f };
  return ctx;
};
